import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

import withComponentName from '../../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const PricingFAQItem = (props) => {
  const {
    id,
    question,
    answer,
    activeFAQid,
    setActiveFAQid,
  } = props;

  return (
    <div className={cx('PricingFAQItem', {
      expand: id === activeFAQid,
    })}
    >
      <div className={cx('PricingFAQItem__head')} onClick={() => setActiveFAQid(id)}>
        <div className={cx('Dot')} />
        <div className={cx('Question')}>
          {question}
        </div>
        <div className={cx('Arrow')}>
          <FontAwesomeIcon icon={id === activeFAQid ? faChevronUp : faChevronDown} />
        </div>
      </div>
      <p
        className={cx('PricingFAQItem__content')}
        dangerouslySetInnerHTML={{ __html: answer }}
      />
    </div>
  );
};

PricingFAQItem.propTypes = {
  id: PropTypes.number,
  question: PropTypes.string,
  answer: PropTypes.string,
  activeFAQid: PropTypes.number,
  setActiveFAQid: PropTypes.func,
};

export default withComponentName(PricingFAQItem);
